import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=51a700fd&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a700fd')) {
      api.createRecord('51a700fd', component.options)
    } else {
      api.reload('51a700fd', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=51a700fd&", function () {
      api.rerender('51a700fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O0CCoyP4zXFA/JS/offershelp.vue"
export default component.exports